// extracted by mini-css-extract-plugin
module.exports =  {"common":"HeaderTitle-module__common___CDAfZ","month":"HeaderTitle-module__month_____fjZ","button":"HeaderTitle-module__button___HwW0d"};